import React, { useState } from "react";
import { Button, Backdrop, CircularProgress } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { getSystemFormattedTimestamp } from "../../../utils/dateFormatted";
import { logger } from "../../../utils/logger";
import { useSelector } from "react-redux";

const DonationPDF = ({ data, type }) => {
  const [loading, setLoading] = useState(false);
  const { user, role } = useSelector((state) => state.auth);
  const PDFtype = type;
  const BaseUrl = process.env.REACT_APP_BASE_URL;

  const handleDownload = async () => {
    setLoading(true);
    try {
      let response;

      if (
        PDFtype === "bookwise-paymodeall" ||
        PDFtype === "bookwise-paymodewise"
      ) {
        response = await fetch(
          `${BaseUrl}api/donationReport/download-book-paymode`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ data, type: PDFtype }),
          }
        );
      } else if (PDFtype === "fundwise") {
        response = await fetch(
          `${BaseUrl}api/donationReport/download-fundwise`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ data, type: PDFtype }),
          }
        );
      } else {
        response = await fetch(`${BaseUrl}api/donationReport/download`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ data, type: PDFtype }),
        });
      }

      if (!response.ok) {
        let errorMsg = "Failed to generate PDF";
        try {
          const errorData = await response.json();
          errorMsg = errorData.message || errorMsg;
        } catch {}
        throw new Error(errorMsg);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${PDFtype} ${getSystemFormattedTimestamp()}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      logger.info("Donation Report PDF Downloaded Successfully", {
        username: user?.username,
        role: role,
        filterType: PDFtype,
        rowsCount: data?.report?.length || 0,
      });
    } catch (err) {
      logger.error("Error downloading Donation Report PDF", {
        username: user?.username,
        role: role,
        filterType: PDFtype,
        rowsCount: data?.report?.length || 0,
      });
      console.error("Error downloading PDF:", err);
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button variant="contained" onClick={handleDownload} color="primary">
        <PictureAsPdfIcon style={{ marginRight: 8 }} />
        Download
      </Button>
      <Backdrop open={loading} style={{ zIndex: 1300, color: "#fff" }}>
        <CircularProgress color="inherit" />
        <span style={{ marginLeft: 10 }}>Generating PDF, please wait...</span>
      </Backdrop>
    </>
  );
};

export default DonationPDF;
